// extracted by mini-css-extract-plugin
module.exports = {"celiaAnimation":"celia-animation-module--celia-animation--2WMuW","celiaContainer":"celia-animation-module--celia-container--1Junl","celia":"celia-animation-module--celia--3sJJr"};